exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button___2D5aj {\n  margin-top: 10px;\n  border-radius: 1rem;\n  color: white;\n  background-color: rgb(219, 165, 236);\n  font-size: 1rem;\n  line-height: 2.2rem;\n  text-align: center;\n  /* margin-left: auto;\n  margin-right: auto; */\n}\n", ""]);

// exports
exports.locals = {
	"button": "button___2D5aj"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/css/wechatBrower.css
// module id = 594
// module chunks = 2